<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="CARGOS" key="1">
          <g-master name="jobs"
                    @params="paramsTable"
                    :endpoint="jobsMaster.endpoint"
                    :tableSetup="jobsMaster.tableSetup"
                    :modalFieldsSetup="jobsMaster.modalFieldsSetup"
                    :useMultipart="true"
                    :beforeSend="jobsMaster.beforeSend"
                    modalWidth="80%"
                    @action="jobsMasterAction">
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in jobsMaster.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-tabs defaultActiveKey="1">
                  <a-tab-pane key="1">
                  <span slot="tab">
                    <a-icon type="vertical-align-top" />
                    Definición del cargo
                  </span>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Cargo')">
                        <a-input v-decorator="['job_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Nombre en inglés')">
                        <a-input
                          v-decorator="['english_job_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Rol')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_h_rol', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                                  :params="id_h_rol_params">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Justificación')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['justification', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Perfil')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['profile', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Subir archivo')" v-bind="fiOptions">
                        <a-upload
                          name="profile_file"
                          :before-upload="beforeUpload"
                          :fileList="jobsMaster.uploads.profileFile"
                          :remove="() => { jobsMaster.uploads.profileFile = [] }">
                          <a-button style="width: 100%">Archivo de perfil</a-button>
                        </a-upload>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Estado')" :has-feedback="false">
                        <a-checkbox v-decorator="['status', {valuePropName: 'checked'}]">
                        </a-checkbox>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Dependencia')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="dependencia"
                                  :decorator="['id_h_dependency', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                  </a-tab-pane>
                  <a-tab-pane key="2">
                  <span slot="tab">
                    <a-icon type="bulb" />
                    Funciones y responsabilidades
                  </span>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Funciones')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['functions', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Responsabilidad')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['responsibility', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Cargos reportados')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['jobs_report', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Complementario')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['complementary', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Med. desarrollo labor')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['sst_develops', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                  </a-tab-pane>
                  <a-tab-pane key="3">
                  <span slot="tab">
                    <a-icon type="pushpin" />
                    Valoración del cargo
                  </span>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Marco de referencia')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="marcoRef"
                                  :decorator="['id_h_framework', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Frec. del contacto')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="frecuenciaContacto"
                                  :decorator="['id_h_frecuency_contact', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Dificultad conceptual')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="difConceptual"
                                  :decorator="['id_h_concept', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Imp. de los resultados')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="impResultados"
                                  :decorator="['id_h_result_impact', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Autoridad y autonomía')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="autYAutonmia"
                                  :decorator="['id_h_autority_autonomy', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('F. académica')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['academic_formation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('N. relación y negocio')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="nivRelNego"
                                  :decorator="['id_lvl_relation', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Experiencia')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="experiencia"
                                  :decorator="['id_h_experience', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Nivel de contribución')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="nivelContribucion"
                                  :decorator="['contribution_level', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Nivel académico')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="nivelAcademico"
                                  :decorator="['id_h_level_academic', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                  </a-tab-pane>
                  <a-tab-pane key="4">
                  <span slot="tab">
                    <a-icon type="medicine-box" />
                    Seguridad y salud del cargo
                  </span>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('C. jefe inmediato')"
                                  :formItemConfig="fiOptions"
                                  endpoint="jobs"
                                  :decorator="['id_job_boss', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Conect. estratégica')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="atributo1"
                                  :decorator="['attribute_1', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Magnitud y tamaño')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="atributo2"
                                  :decorator="['attribute_2', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Prueba polígrafo')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="atributo3"
                                  :decorator="['attribute_3', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown :label="$t('Tipo de contacto')"
                                  :formItemConfig="fiOptions"
                                  endpoint="hierarchy_lookup"
                                  :params="tipoContacto"
                                  :decorator="['id_h_contact_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Valoración')">
                        <a-input-number  style="width: 100%"
                                         v-decorator="['valoration', { rules: [{ required: false, message: 'Valor requerido' }]}]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Factores de riesgo')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['sst_riks_factor', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Exám. médicos req.')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['sst_medical_exam', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Estándar de seguridad')" v-bind="fiOptions">
                        <a-textarea autoSize
                                    v-decorator="['sst_security_standard', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                  </a-tab-pane>
                </a-tabs>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="COMPETENCIAS DE TRABAJO" key="1">
          <jobs-competency v-if="idJobSeleccionado" :job-id="idJobSeleccionado">
          </jobs-competency>
          <span v-else>Seleccione un cargo para visualizar las competencias de trabajo.</span>
        </a-tab-pane>
        <a-tab-pane tab="LOGISTICA DEL CARGO" key="2">
          <jobs-assets v-if="idJobSeleccionado" :job-id="idJobSeleccionado"></jobs-assets>
          <span v-else>Seleccione un cargo para visualizar la logística del cargo.</span>
        </a-tab-pane>
        <a-tab-pane tab="ACCESO AL TRABAJO" key="3">
          <jobs-access v-if="idJobSeleccionado" :job-id="idJobSeleccionado">
          </jobs-access>
          <span v-else>Seleccione un cargo para visualizar el acceso al trabajo.</span>
        </a-tab-pane>

      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        dependencia: {
          h_lookup_type: 'DEPENDENCIA'
        },
        nivelContribucion: {
          h_lookup_type: 'NIVEL_CONTRIBUCION'
        },
        nivelAcademico: {
          h_lookup_type: 'NIVEL_ESTUDIO'
        },
        experiencia: {
          h_lookup_type: 'EXPERIENCIA'
        },
        atributo1: {
          h_lookup_type: 'CONECTIVIDAD_ESTRATEGICA'
        },
        atributo2: {
          h_lookup_type: 'MAGNITUD_TAMANO'
        },
        atributo3: {
          h_lookup_type: 'ATRIBUTO_DISCIPLINARIO_3'
        },
        tipoContacto: {
          h_lookup_type: 'TIPO_DE_CONTACTO'
        },
        frecuenciaContacto: {
          h_lookup_type: 'FRECUENCIA_CONTACTO'
        },
        nivRelNego: {
          h_lookup_type: 'NIV_RELACION_NEGOCIACION'
        },
        difConceptual: {
          h_lookup_type: 'DIFICULTAD_CONCEPTUAL'
        },
        marcoRef: {
          h_lookup_type: 'MARCO_REFERENCIA'
        },
        impResultados: {
          h_lookup_type: 'IMPACTO_RESULTADOS'
        },
        autYAutonmia: {
          h_lookup_type: 'AUTORIDAD_AUTONOMIA'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        loadingBtns: {},
        filaSeleccionada: [],
        id_h_rol_params: {
          h_lookup_type: 'ROL DEL CARGO'
        },
        jobsMaster: {
          valoresExpandidos: [
            {label: 'Dependencia', column: 'id_h_dependency_desc'},
            {label: 'ID jefe', column: 'id_job_boss'},
            {label: 'Nivel de contribución', column: 'contribution_level_desc'},
            {label: 'Nivel académico', column: 'id_h_level_academic_desc'},
            {label: 'Experiencia', column: 'id_h_experience_desc'},
            {label: 'Conect. estratégica', column: 'attribute_1_desc'},
            {label: 'Magnitud y tamaño', column: 'attribute_2_desc'},
            {label: 'Prueba polígrafo', column: 'attribute_3_desc'},
            {label: 'Tipo de contacto', column: 'id_h_contact_type_desc'},
            {label: 'Frecuencia del contacto', column: 'id_h_frecuency_contact_desc'},
            {label: 'Nivel de relación y negocio', column: 'id_lvl_relation_desc'},
            {label: 'Dificultad conceptual', column: 'id_h_concept_desc'},
            {label: 'Marco referencial', column: 'id_h_framework_desc'},
            {label: 'Impacto de los resultados', column: 'id_h_result_impact_desc'},
            {label: 'Autoridad y autonomía', column: 'id_h_autority_autonomy_desc'},
            {label: 'Valoración', column: 'valoration'},
            {label: 'Complementarios', column: 'complementary'},
            {label: 'Formación académica', column: 'academic_formation'},
            {label: 'Cargos reportados', column: 'jobs_report'},
            {label: 'Responsabilidad', column: 'responsibility'},
            {label: 'Funciones', column: 'functions'},
            {label: 'Med. desarrollo labor', column: 'sst_develops'},
            {label: 'Factores de riesgo', column: 'sst_riks_factor'},
            {label: 'Exámenes médicos requeridos', column: 'sst_medical_exam'},
            {label: 'Estándar de seguridad', column: 'sst_security_standard'},
          ],
          endpoint: 'jobs',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            columns: [
              {title: '#', dataIndex: 'id_job', sorter: true},
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Cargo en inglés', dataIndex: 'english_job_name', sorter: true},
              {title: 'Rol', dataIndex: 'h_rol', sorter: true},
              {title: 'Justificación', dataIndex: 'justification', sorter: true},
              {title: 'Perfil', dataIndex: 'profile', sorter: true}
            ],
            tableConfig: {
              rowKey: 'id_job'
            },
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_job] === record.id_job
                  }
                }
              ]
            },
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'job_name'},
            {name: 'english_job_name'},
            {name: 'id_h_rol'},
            {name: 'status'},
            {name: 'justification'},
            {name: 'profile'},
            {name: 'id_h_dependency'},
            {name: 'id_job_boss'},
            {name: 'contribution_level'},
            {name: 'id_h_level_academic'},
            {name: 'id_h_experience'},
            {name: 'attribute_1'},
            {name: 'attribute_2'},
            {name: 'attribute_3'},
            {name: 'id_h_contact_type'},
            {name: 'id_h_frecuency_contact'},
            {name: 'id_lvl_relation'},
            {name: 'id_h_concept'},
            {name: 'id_h_framework'},
            {name: 'id_h_result_impact'},
            {name: 'id_h_autority_autonomy'},
            {name: 'valoration'},
            {name: 'complementary'},
            {name: 'academic_formation'},
            {name: 'jobs_report'},
            {name: 'responsibility'},
            {name: 'functions'},
            {name: 'sst_develops'},
            {name: 'sst_riks_factor'},
            {name: 'sst_medical_exam'},
            {name: 'sst_security_standard'}
          ],
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.jobsMaster.uploads.profileFile.length > 0) {
              data.profileFile = this.jobsMaster.uploads.profileFile[0]
            }
            return data
          }
        },
        endpointExcel: 'jobs_/downloadExcel',
        fileNameExcel: 'Cargos',
        paramsT: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      jobsMasterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.jobsMaster.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id_job] = record.id_job
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('jobs/download', {
          id_job: record.id_job
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_job]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.jobsMaster.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const isJpgOrPng = file.type === 'application/pdf'
        if (!isJpgOrPng) {
          this.$message.error('Solo se pemiten documentos pdf')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      idJobSeleccionado () {
        return this.jobsMaster.tableSetup.selectedRows.length > 0 ? this.jobsMaster.tableSetup.selectedRows[0].id_job : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.jobsMaster.tableSetup.columns}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Jobs/Jobs.vue